import axios from '@utils/axios';
import router from '@router/router';

const editSample = {
  state: {
    sampleId: 0,
    status: 1,
    customerId: 0,
    customerName: '',
    updatedAt: '',
    hasBarcode: false
  },
  mutations: {
    setSampleId(state, id) {
      state.sampleId = id;
    },
    setStatus(state, status) {
      state.status = status;
    },
    setCustomerId(state, customerId) {
      state.customerId = customerId;
    },
    setCustomerName(state, email) {
      state.customerName = email;
    },
    setUpdatedAt(state, at) {
      state.updatedAt = at;
    },
    setHasBarcode(state, hasBarcode) {
      state.hasBarcode = hasBarcode;
    }
  },
  actions: {
    fetchSample(context) {
      return axios.get('admin/samples/sample', {
        params: {
          SampleId: context.state.sampleId
        }
      })
        .then((res) => {
          if (res.status === 404) {
            router.push({ name: 'admin.samples.view' });
          } else if (res.status === 200) {
            context.commit('setStatus', res.data.result.status);
            context.commit('setCustomerId', res.data.result.customerId);
            context.commit('setCustomerName', res.data.result.customerName);
            context.commit('setUpdatedAt', res.data.result.updatedAt);
            context.commit('setHasBarcode', res.data.result.hasBarcode);
            Promise.resolve(true);
          }
        }).catch(() => {
          router.push({ name: 'admin.dashboard' });
        });
    },
    editSample(context) {
      return axios.post('admin/samples/', {
        SampleId: Number(context.state.sampleId),
        Status: context.state.status
      });
    },
    resetContext(context) {
      context.commit('setSampleId', 0);
      context.commit('setStatus', 1);
      context.commit('setCustomerId', 0);
      context.commit('setCustomerName', '');
      context.commit('setUpdatedAt', '');
      context.commit('setHasBarcode', false);
    }
  },
  namespaced: true
};

export default editSample;
